import { AppBaseProps, CommonApp, CommonAppProps, Context, Entity } from "../core/components/commonApp.js";
import { AppHelper } from "../appHelper.js";
import { ExtendedProjectFilterHistory, ExtendedProjectFilterHistoryProps } from "./extendedProjectFilterHistory.js";
import { Helper } from "../core/util/helper.js";
import { Config } from "../core/config/config.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { EntityProject } from "../project/project.js";
import { General } from "../../siteManagement/general.js";
import { ResourcePlanningSchedulerSettingsViewModel } from "./resourcePlanningScheduler.js";
import React from "react";
export class ExtendedProjectFilter extends React.Component<ExtendedProjectFilterProps, ExtendedProjectFilterState> {
    common = new AppHelper();
    projectFilterHistoryGridOptions;
    private init = true;
    private _id;
    constructor(props: ExtendedProjectFilterProps | Readonly<ExtendedProjectFilterProps>) {
        super(props);
        this.state = {
            ProjectFilterHistoryGridData: this.getGridData(this.props.entity.ProjectFilterHistoryGridData)
        };
        this.common.enableHooks = true;
        this.common.init(this);
        const sheet = General.Sheet.Manager.getTopMostSheet();
        this._id = sheet.id();
    }
    private buildHistory = (gridData: HistoryEntityProject[]) => {
        let limitedGridData = this.limitHistory(gridData);
        let history = limitedGridData.map(g => {
            let item: ProjectFilterHistoryItem = {
                ProjNr: g.Projnr,
                Active: g.Active,
                CreateDate: g.CreateDate
            };
            return item;
        });
        return history;
    }

    private limitHistory = (history: HistoryEntityProject[]) => {
        let sortedHistory = history.sort(this.sort);
        let newListItems: HistoryEntityProject[] = JSON.parse(JSON.stringify(history)).sort(this.sort);
        if (sortedHistory.length > Config.settings.extendedProjectFilterLimit) {
            // Wenn zuviele aktiv dann gilt die Ursprungsregel
            // Prüfung der aktivierten Projektnummern!
            let activatedProjNrs = sortedHistory.filter(h => h.Active);
            let deactivatedProjNrs = sortedHistory.filter(h => !h.Active).sort(this.sort);
            if (activatedProjNrs.length <= Config.settings.extendedProjectFilterLimit) {
                for (let i = deactivatedProjNrs.length - 1; i >= 0; i--) {
                    if (newListItems.length > Config.settings.extendedProjectFilterLimit) {
                        let index = newListItems.findIndex(historyProj => historyProj.Projnr === deactivatedProjNrs[i].Projnr);
                        if (index > -1) {
                            newListItems.splice(index, 1);
                        }
                    }
                }
            }
            if (newListItems.length > Config.settings.extendedProjectFilterLimit) {
                for (let i = Config.settings.extendedProjectFilterLimit; i < sortedHistory.length; i++) {
                    let index = newListItems.findIndex(historyProj => historyProj.Projnr === sortedHistory[i].Projnr);
                    if (index > -1) {
                        newListItems.splice(index, 1);
                    }
                }
            }

            return newListItems;
        }
        return history;
    }
    save = () => {
        let history = this.buildHistory(this.state.ProjectFilterHistoryGridData);
        let activatedProjNrs = history.filter(h => h.Active).map(h => h.ProjNr);
        let entity: ExtendedProjectFilterEntity = JSON.parse(JSON.stringify(this.props.entity));
        entity.ProjNrs = activatedProjNrs;
        entity.ProjectFilterHistory = history;
        entity.ProjectFilterHistoryGridData = this.state.ProjectFilterHistoryGridData;
        Helper.updateEntity(this.props.entity, entity);
        this.common.handlePostSave(true, true);
    }
    renderHistory = () => {
        let gridData = JSON.parse(JSON.stringify(this.state.ProjectFilterHistoryGridData)).sort(this.sort);
        const props: ExtendedProjectFilterHistoryProps = {
            GridData: gridData,
            GridOptions: this.projectFilterHistoryGridOptions,
            entity: this.props.entity,
            updateItems: (items) => {
                this.common.setEntityDirtyState(true);
                this.setState({ ProjectFilterHistoryGridData: items }, async () => {
                    this.changeActiveLabel();
                    if (this.props.entity.TakeOverProjectTimeSpans) {
                        await this.validateProjectTimeSpanLimit();
                    }
                });
            },
            limit: Config.settings.extendedProjectFilterLimit,
            FavoriteFilterName: this.props.FavoriteFilterName,
            FavoriteFilterId: this.props.FavoriteFilterId
        };

        return <ExtendedProjectFilterHistory {...props} />
    }
    private sort = (a: HistoryEntityProject, b: HistoryEntityProject) => {
        if (a.CreateDate > b.CreateDate)
            return -1;
        if (a.CreateDate < b.CreateDate)
            return 1;
        return 0;
    }
    private getTimeSpan = (start, end, diffDays) => {
        return kendo.toString(start, Helper.getLocalDateformat(), Config.user.culture) + " - " + kendo.toString(end, Helper.getLocalDateformat(), Config.user.culture) + (diffDays > Config.user.projectRangeLimit ? " (" + Helper.getTranslation("Projekt.DaysOverProjectTimeLimit").replace("{days}", (diffDays - Config.user.projectRangeLimit).toString()) + ")" : "")
    }
    private getGridItem = (item: any) => {
        let end = new Date(item.Endeist);
        let start = new Date(item.Startist);
        let diff = Math.abs(end.getTime() - start.getTime());
        let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
        return $.extend({
            Active: true,
            CreateDate: new Date(Date.now()),
            TimeSpan: this.getTimeSpan(start, end, diffDays),
            TooLarge: diffDays > Config.user.projectRangeLimit
        }, item);
    }
    private getGridData = (data: any[]) => {
        return data.map(item => {
            return this.getGridItem(item);
        });
    }
    private handleFieldChange = async (field: { model: string }, value, dataItem) => {
        if (field.model === "entity.ChoosedProjNrs") {
            let history: any[] = JSON.parse(JSON.stringify(this.state.ProjectFilterHistoryGridData));
            if (Array.isArray(dataItem)) {
                let projNrs = dataItem.map(d => d.projnr).filter(d => history.findIndex(h => h.Projnr === d) === -1);
                let result = await HTTPService.post<JsonResultClass<any[]>>("ProjectLookup/GetProjects", { projNrs: projNrs });
                if (result.Code === 0) {
                    let newItems: HistoryEntityProject[] = this.getGridData(result.Data);
                    if ((history.length + newItems.length) > Config.settings.extendedProjectFilterLimit) {
                        let newList: HistoryEntityProject[] = history.concat(newItems).sort(this.sort);
                        let newListItems: HistoryEntityProject[] = JSON.parse(JSON.stringify(newList));
                        for (let i = history.length; i < newList.length; i++) {
                            if (i + 1 > Config.settings.extendedProjectFilterLimit) {
                                let index = newListItems.findIndex(historyProj => historyProj.Projnr === newList[i].Projnr);
                                if (index > -1) {
                                    newListItems.splice(index, 1);
                                }
                            }
                        }
                        history = newListItems;
                    } else {
                        history.push.apply(history, newItems);
                    }
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            } else if (dataItem) {
                if (history.filter(i => i.Projnr == dataItem.ProjNr).length === 0) {
                    let result = await HTTPService.get<JsonResultClass>("Project/Get?id=" + dataItem.ProjNr);
                    if (result.Code === 0) {
                        if (history.length + 1 > Config.settings.extendedProjectFilterLimit) {
                            history = history.sort(this.sort);
                            history.splice(history.length - 1, 1);
                        }
                        history.push(this.getGridItem(result.Data));
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                }
            }
            this.setState({ ProjectFilterHistoryGridData: history }, async () => {
                // this.changeActiveLabel();
                if (this.props.entity.TakeOverProjectTimeSpans) {
                    await this.validateProjectTimeSpanLimit();
                }
            });
            dataItem = null;
            value = null;
        }
        else if (field.model == "entity.TakeOverProjectTimeSpans") {
            if (value) {
                await this.validateProjectTimeSpanLimit();
            } else {
                this.deleteProjectRangeLimitText();
            }
        } else if (this.props.entity.TakeOverProjectTimeSpans && field.model !== "Active") {
            await this.validateProjectTimeSpanLimit();
        }
        if (field.model !== "Active") {
            await this.handleFieldChange({ model: "Active" }, true, null);
        }
        this.common.handleFieldChange(field, value, dataItem);
    }
    private validateProjectTimeSpanLimit = async () => {
        const result = await HTTPService.post<JsonResultClass<{
            Key: keyof ResourcePlanningSchedulerSettingsViewModel,
            Value: any
        }[]>>('ResourcePlanning/GetProjectDates', { projNrs: this.state.ProjectFilterHistoryGridData.filter(p => p.Active).map(p => p.Projnr) });
        if (result.Code === 0) {
            let end = new Date(result.Data.find(d => d.Key == "End")?.Value);
            let start = new Date(result.Data.find(d => d.Key == "Start")?.Value);
            let diff = Math.abs(end.getTime() - start.getTime());
            let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
            if (diffDays > Config.user.projectRangeLimit) {
                let elem = "<p class='field__value__label' style='color: red; width: 90%;' id='projectRangeLimitText'>" + Helper.getTranslation("Projekt.ProjectTImeSpanLimitWarning").replace("{days}", Config.user.projectRangeLimit.toString()) + "</p>";
                this.deleteProjectRangeLimitText();
                $('div.field-instance[data-model="entity.TakeOverProjectTimeSpans"]').find('.k-invalid-msg').append(elem);
                $('div.field-instance[data-model="entity.TakeOverProjectTimeSpans"]').find('.k-invalid-msg').attr('style', 'display: inline-flex; justify-content: flex-end;')
            } else {
                this.deleteProjectRangeLimitText();
            }
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }
    private deleteProjectRangeLimitText = () => {
        $('div.field-instance[data-model="entity.TakeOverProjectTimeSpans"]').find('.k-invalid-msg').find("p[id='projectRangeLimitText']").remove();
    }
    private changeActiveLabel = () => {
        this.init = false;
        let elem: string;

        if (Helper.hasValue(this.props.FavoriteFilterId) || !this.props.entity.Active) {
            let reason = " (" + Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.ProjNrsNotLoaded") + ")";
            if (Helper.hasValue(this.props.FavoriteFilterId)) {
                reason = " (" + Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.ActiveFavoriteFilter").replace("{filter}", this.props.FavoriteFilterName) + ")";
            } else if (this.props.entity.ProjNrs.length == 0) {
                reason = "";
            }
            elem = "<div id='activeLabel' style='padding: 2px; color: rgb(255, 255, 255); background-color: rgb(255, 0, 0); border: 2px solid rgba(0, 0, 0, 0.25); border-radius: var(--border-radius); align-items: center; text-align: center; margin-left: 5px;'>" + Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.Inactive") + reason + "<i class='fas fa-times-circle' style='color: rgba(0,0,0,0.25); margin-left: 5px;'></i></div>";
        } else {
            elem = "<div id='activeLabel' style='padding: 2px; color: rgb(0, 0, 0); background-color: rgb(0, 255, 64); border: 2px solid rgba(0, 0, 0, 0.25); border-radius: var(--border-radius); align-items: center; text-align: center; margin-left: 5px;'>" + Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.Active") + "<i class='fas fa-check-circle' style='color: rgba(0,0,0,0.25); margin-left: 5px;'></i></div>";
        }
        General.Sheet.Manager.getSheetById(this._id).elements.getTitleRef().closest('.sheet__title__label').find("div[id='activeLabel']").remove();
        General.Sheet.Manager.getSheetById(this._id).elements.getTitleRef().closest('.sheet__title__label').append(elem);
    }
    componentDidMount() {
        this.changeActiveLabel();
    }

    render() {
        const props: CommonAppProps = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />
    }
}
export interface ExtendedProjectFilterProps extends AppBaseProps {
    entity: ExtendedProjectFilterEntity;
    context: ExtendedProjectFilterContext;
    FavoriteFilterName?: string;
    FavoriteFilterId?: string;
}

export interface HistoryEntityProject extends EntityProject {
    Active: boolean;
    CreateDate?: Date;
    TimeSpan?: string;
    TooLarge?: boolean;
}
interface ExtendedProjectFilterState {
    ProjectFilterHistoryGridData: HistoryEntityProject[];
}
interface ExtendedProjectFilterContext extends Context {
    projectFilterHistoryGridOptions: any;
}
export interface ExtendedProjectFilterEntity extends Entity {
    ProjectFilterHistoryGridData: HistoryEntityProject[];
    ProjectFilterHistory: ProjectFilterHistoryItem[];
    ProjNrs: string[];
    ChoosedProjNrs: any[];
    TakeOverProjectTimeSpans: boolean;
    ProjektfilterAlleEinsaetzeAnzeigen: boolean;
    Active: boolean;
}
export interface ProjectFilterHistoryItem {
    ProjNr: string;
    Active: boolean;
    CreateDate: Date;
}